<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane name="Annonces" :label="$t('socialPosts.list.postAnnonces')">
          <SocialPostsTableAnnonces
              v-on:show-modale-delete="$emit('show-modale-delete',$event)"
              :selected-posts-annonces="selectedPostsAnnonces"
          />
    </el-tab-pane>
    <el-tab-pane name="BienVendus" :label="$t('socialPosts.list.biensVendus')" v-if="universe !== 'VO' && possedeBiensVendus === true">
          <SocialPostsTableBiensVendus :selected-posts-b-v="selectedPostsBV"/>
    </el-tab-pane>
    <el-tab-pane name="PostsEditoriaux" :label="$t('socialPosts.list.postsEditoriaux')" v-if="possedeEdito">
          <SocialPostsTableEditoriaux />
    </el-tab-pane>
  </el-tabs>
</template>

<script>

import SocialPostsTableAnnonces from '@/pages/socialNetworks/Blocks/SocialPostsTableAnnonces'
import SocialPostsTableBiensVendus from '@/pages/socialNetworks/Blocks/SocialPostsTableBiensVendus'
import SocialPostsTableEditoriaux from '@/pages/socialNetworks/Blocks/SocialPostsTableEditoriaux'
import { Tabs, TabPane } from 'element-ui'
export default {
  name: 'SocialPostsListTable',
  components: {
    SocialPostsTableAnnonces,
    SocialPostsTableBiensVendus,
    SocialPostsTableEditoriaux,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  data () {
    return {
      activeName: 'Annonces',
      toto: null
    }
  },
  props: ['selectedPostsAnnonces', 'selectedPostsBV'],
  computed: {
    universe () {
      return this.sitimmoUser.univers
    },
    possedeEdito () {
      return this.sitimmoUser.optionEdito
    },
    possedeBiensVendus () {
      return this.sitimmoUser.soldProductsOption
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  beforeMount () {
    this.activeName = this.$store.state.socialNetworkPosts.currentTab
    switch (this.activeName) {
      case 'Annonces' :
        this.$emit('changetab', 'Annonces')
        this.$store.commit('socialNetworkPosts/setCurrentTab', 'Annonces')
        break
      case 'BienVendus' :
        this.$emit('changetab', 'BienVendus')
        this.$store.commit('socialNetworkPosts/setCurrentTab', 'BienVendus')
        break
      case 'PostsEditoriaux' :
        this.$emit('changetab', 'PostsEditoriaux')
        this.$store.commit('socialNetworkPosts/setCurrentTab', 'PostsEditoriaux')
        break
    }
  },
  methods: {
    handleClick (tab, event) {
      switch (tab.name) {
        case 'Annonces' :
          this.$emit('changetab', 'Annonces')
          this.$store.commit('socialNetworkPosts/setCurrentTab', 'Annonces')
          break
        case 'BienVendus' :
          this.$emit('changetab', 'BienVendus')
          this.$store.commit('socialNetworkPosts/setCurrentTab', 'BienVendus')
          break
        case 'PostsEditoriaux' :
          this.$emit('changetab', 'PostsEditoriaux')
          this.$store.commit('socialNetworkPosts/setCurrentTab', 'PostsEditoriaux')
          break
      }
    }
  }
}

</script>

<style scoped>

</style>
